import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Sound from 'react-sound';
import audio_play from '../static/audio_play.svg';
import img_display from '../static/img_display.svg';
import questionMark from '../static/q_gray.png';

export const Vocabulary = ({ data }) => {
  return (
    <div className='wn-qz-tb-vc'>
      <table>
        <thead>
          <tr>
            <td className='index'>番号</td>
            <td className='question'>質問</td>
            <td className='answer'>正解</td>
            <td className='user_answer'>回答</td>
          </tr>
        </thead>
        <tbody>
          {data.map((qna, j) => (
            <tr key={'quiz_log_' + j}>
              <td className='index'>{j + 1}</td>
              <td className='question'>{qna.ja_jp}</td>
              <td className='answer'>{qna.en_us}</td>
              <td className='user_answer'>
                <div className='mobile'>
                  <div className='answer_btn'>
                    <div className='dropdown'>
                      <a
                        id={'voca_' + j}
                        onClick={answerClick.bind(`voca_${j}`)}
                      >
                        <img alt={`questionMark`} src={questionMark} />
                      </a>
                      <div className='dropdown-content'>
                        <p>{qna.en_us}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>{qna.user}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const Pattern = ({ data }) => {
  return (
    <div>
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={12} className='wn-qz-tb-pt'>
              <table>
                <thead>
                  <tr>
                    <td className='index'>番号</td>
                    <td className='question'>
                      <div className='desktop'>質問</div>
                      <div className='mobile'>質問 & 回答</div>
                    </td>
                    <td className='answer'>正解</td>
                    <td className='user_answer'>回答</td>
                  </tr>
                </thead>
                <tbody>
                  {data.map((qna, i) => (
                    <tr key={'quiz_log_' + i}>
                      <td className='index'>{i + 1}</td>
                      <td className='question'>
                        {qna.ja_jp}
                        <div className='mobile'>
                          <div className='answer_btn'>
                            <div className='dropdown'>
                              <a
                                id={'pattern_' + i}
                                onClick={answerClick.bind(`pattern_${i}`)}
                              >
                                <img alt={`questionMark`} src={questionMark} />
                              </a>
                              <div className='dropdown-content'>
                                <p>{qna.en_us}</p>
                              </div>
                            </div>
                          </div>
                          <div className='us_an'>{qna.user}</div>
                        </div>
                      </td>
                      <td className='answer'>{qna.en_us}</td>
                      <td className='user_answer'>{qna.user}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

function answerClick() {
  document.getElementById(this).className = 'active';
}

export const Dialogue = ({ data }) => {
  return (
    <div>
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={12} className='wn-qz-tb-dl'>
              <table>
                <thead>
                  <tr>
                    <td className='index'>番号</td>
                    <td className='question'>
                      <div className='desktop'>質問</div>
                      <div className='mobile'>質問 & 回答</div>
                    </td>
                    <td className='answer'>正解</td>
                    <td className='user_answer'>回答</td>
                  </tr>
                </thead>
                <tbody>
                  {data.map((qna, i) => (
                    <tr key={'quiz_log_' + i}>
                      <td className='index'>{i + 1}</td>
                      <td className='question'>
                        {qna.ja_jp}
                        <div className='mobile'>
                          <div className='answer_btn'>
                            <div className='dropdown'>
                              <a
                                id={'dialog_' + i}
                                onClick={answerClick.bind(`dialog_${i}`)}
                              >
                                <img alt={`questionMark`} src={questionMark} />
                              </a>
                              <div className='dropdown-content'>
                                <p>{qna.en_us}</p>
                              </div>
                            </div>
                          </div>
                          <div className='us_an'>{qna.user}</div>
                        </div>
                      </td>
                      <td className='answer'>{qna.en_us}</td>
                      <td className='user_answer'>{qna.user}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

function clickclick2() {
  let id = this;
  document.getElementById(id).className = 'active';
}

const choices = ['A', 'B', 'C', 'D'];

function choiceRow(choice, i, j, type, user_answer, answer, sound, handlers) {
  let { onAudioPlay, onAudioEnd } = handlers;
  let { audio, display } = choice;
  let imgTarget = 'answer-' + i + '-' + j;

  return (
    <tr
      className={'choice-row ' + (choices[j] === answer ? 'answer' : '')}
      key={'choice_' + i + '_' + j}
    >
      <td></td>
      <td className='main-td'>
        <div>
          <input
            type='radio'
            disabled
            readOnly
            checked={user_answer === choices[j] ? true : false}
          />
          <div className='choice-text'>
            <span>
              {choices[j]}. {choice.audio.text}
            </span>
          </div>
          {audio.resource && (
            <div className='sound'>
              <a
                role='button'
                name='choices'
                onClick={e => onAudioPlay(i, j, e)}
              >
                <img src={audio_play} alt='audio img' />
              </a>
              <Sound
                url={audio.resource}
                playStatus={sound.choices[j]}
                onFinishedPalying={onAudioEnd}
              />
            </div>
          )}
          {choice.display.resource && (
            <div className='dropdown'>
              <a
                className='bbb'
                id={imgTarget}
                onClick={clickclick2.bind(imgTarget)}
              >
                <img src={img_display} alt='img dropdown button' />
              </a>
              <div className='dropdown-content'>
                <p>
                  <img src={display.resource} alt={`choice${j}_img`} />
                </p>
              </div>
            </div>
          )}
        </div>
      </td>
      <td></td>
    </tr>
  );
}

function spanText(type, text) {
  return <span className={`${type}_audio_text`}>{text}</span>;
}

function divImage(type, src, i) {
  return (
    <img className={`${type}_image`} src={src} alt={`${type}_${i}_image`} />
  );
}

function divSound(type, src, i, sound, handlers) {
  return (
    <div className={`${type}_row sound`}>
      <a role='button' name={type} onClick={e => handlers.onAudioPlay(i, 0, e)}>
        <img src={audio_play} alt='audio img' />
      </a>
      <Sound
        url={src}
        playStatus={sound}
        onFinishedPalying={handlers.onAudioEnd}
      />
    </div>
  );
}

/* flow

*/
function headerRow(data, type, sound, handlers, i) {
  let { audio, display } = data;
  return (
    <div className={`${type}_row`}>
      {display.resource ? (
        <div>
          <div className={`${type}_row_1 img`}>
            {divImage(type, display.resource, i)}
            {audio.resource &&
              divSound(type, audio.resource, i, sound, handlers)}
          </div>
          {audio.text ? (
            <div>{spanText(type, audio.text)}</div>
          ) : display.text ? (
            <div>{spanText(type, display.text)}</div>
          ) : (
            <div></div>
          )}
        </div>
      ) : (
        <div className={`${type}_row_2`}>
          {audio.text && spanText(type, audio.text)}
          {audio.resource && divSound(type, audio.resource, i)}
        </div>
      )}
    </div>
  );
}

// if more quiz type is added this code needs to updated (very poor scalability)
function questionRow(quiz, i, sound, handlers) {
  let { header } = quiz;
  return (
    <tr className='question-row' key={'question+' + i}>
      <td>{i + 1}</td>
      <td className='main-td'>
        {headerRow(header.material, 'material', sound.material, handlers, i)}
        {headerRow(header.question, 'question', sound.question, handlers, i)}
      </td>
      <td></td>
    </tr>
  );
}

export const Quiz = ({ data, sound, handlers }) => {
  let quizBody = [];

  data.forEach((quiz, i) => {
    quizBody.push(questionRow(quiz, i, sound[i], handlers));
    quiz.body.forEach((choice, j) => {
      quizBody.push(
        choiceRow(
          choice,
          i,
          j,
          quiz.type,
          quiz.user_answer,
          quiz.answer,
          sound[i],
          handlers
        )
      );
    });
  });

  return (
    <Row>
      <Col xs={12}>
        <div className='quiz_table'>
          <table className='quiz day4'>
            <thead>
              <tr>
                <td>番号</td>
                <td className='main-td'>質問</td>
                <td></td>
              </tr>
            </thead>
            <tbody>{quizBody}</tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Note.Quizzes.js